"use client";

import { AlertCircle, Truck } from "@/components/icons";
import { FreightForm } from "./freight-form";
import { FreightQuoteResult } from "./freight-quote-result";
import { useFreightQuote } from "./use-freight-quote";
import { useToolComputed } from "@/hooks/use-tool-computed";

export default function FreightCalculator() {
  const freightQuote = useFreightQuote();
  useToolComputed("freight-calculator", freightQuote.quote ? JSON.stringify(freightQuote.quote) : null);

  return (
    <div className="mx-auto max-w-2xl">
      <div className="border border-border bg-card">
        <div className="flex items-center gap-2 border-b border-border bg-muted px-6 py-3">
          <Truck aria-hidden className="h-4 w-4 text-muted-foreground" />
          <span className="text-xs font-medium text-muted-foreground">Quote Details</span>
        </div>
        <FreightForm
          inputs={freightQuote.inputs}
          shippingMode={freightQuote.shippingMode}
          originLabel={freightQuote.originLabel}
          destLabel={freightQuote.destLabel}
          isLoading={freightQuote.isLoading}
          canFetchQuote={freightQuote.canFetchQuote}
          onChange={freightQuote.update}
          onFetchQuote={() => void freightQuote.fetchQuote()}
        />
      </div>
      {freightQuote.error ? (
        <div role="alert" className="mt-4 flex items-center gap-2 border border-destructive/30 bg-destructive-bg px-4 py-3">
          <AlertCircle aria-hidden className="h-4 w-4 shrink-0 text-destructive-strong" />
          <p className="text-sm text-destructive-strong">{freightQuote.error}</p>
        </div>
      ) : null}
      {freightQuote.quote ? <FreightQuoteResult quote={freightQuote.quote} /> : null}
    </div>
  );
}
